import { ref } from '@vue/composition-api'

export default function useFilterReport ({ baseUrl, fetchLists }) {
  const baseReportUrl = ref(baseUrl)
  const periodReportText = ref()
  const officeReportText = ref()
  const periodeTypeText = ref()

  const getReport = async ({ generatedUrl, periodText, officeText, periodeType }) => {
    await fetchLists(generatedUrl)
    periodReportText.value = periodText
    officeReportText.value = officeText
    periodeTypeText.value = periodeType
  }

  return {
    baseReportUrl,
    periodReportText,
    officeReportText,
    getReport,
    periodeTypeText
  }
}
